import FetchService from './base.fetch';
import StoreService from './store';
import CONSTANT from '../../constant';
import mElectron from '../../util/electron';
import {getInternational} from '../../util/env';
import Config from '../../config';
import OSS from 'ali-oss';

/**
 * 阿里云数据服务
 *
 * @export
 * @class OssService
 */
class OssService {

    /**
     * Creates an instance of OssService.
     * @memberof OssService
     */
    constructor() {
        this.domain = FetchService.domainconfig.cloud[getInternational()];

        const apisConfig = {
            // 获取云端用户作品下载令牌
            downloadToken: {
                // method: 'get',
                // url: 'cloud/token/access'
                method: 'POST',
                url: 'project/accesstoken'
            },
            // 获取作品上传令牌
            uploadToken: {
                method: 'get',
                url: 'cloud/token/upload'
            },
            // 获取封面上传令牌
            uploadImgToken: {
                method: 'get',
                url: 'cloud/token/coverupload'
            },
            // 获取附件上传令牌
            uploadAttachToken: {
                method: 'get',
                url: 'cloud/token/attachmentupload'
            }
        };
        this.client = null;
        FetchService.configToRequestAction.call(this, apisConfig, FetchService);
    }

    /**
     * 获取远程文件的下载路径
     *
     * @param {Object} config
     */
    fetchFileUrl(config) {
        const client = new OSS({
            region: config.region,
            accessKeyId: config.accessKeyId,
            accessKeySecret: config.accessKeySecret,
            stsToken: config.stsToken,
            bucket: config.bucket
        });
        const downloadPath = client.signatureUrl(config.commitId, {
            expires: 3600,
            response: {
                'content-disposition': 'attachment; filename="' + config.localName + '"'
            }
        });
        return downloadPath;
    }

    /**
     * 下载文件
     *
     * @param {any} config
     * @param {any} cb
     * @returns
     */
    downloadFile(config, cb) {
        const downloadPath = this.fetchFileUrl(config);
        const savePath = Config.userProjectFilePath + '/' + config.localName + '.mblock';
        mElectron.downloadFile(downloadPath, savePath, config.localName, (err, data) => cb(err, data));
    }

    /**
     * 下载文件封面
     *
     * @param {any} config
     * @param {any} cb
     * @returns
     */
    downloadCoverImage(config, cb) {
        const { url, filePath, fileName } = config;
        mElectron.downloadFile(url, filePath, fileName, (err) => cb(err));
    }

    /**
     * 上传文件
     *
     * @param {any} config
     * @param {any} cb
     * @returns
     */
    uploadFile(uploadObj) {
        const {config, file, info, option } = uploadObj;
        const { region, accessKeyId, accessKeySecret, stsToken, bucket, commitId, callbackUrl } = config;
        const { projectId, projectName, localName, createdAt, coverImage, isSelfProject } = info;
        const client = new OSS({ region, accessKeyId, accessKeySecret, stsToken, bucket });
        const callbackBody = 'coverImage=${x:coverImage}&utoken=${x:utoken}&pid=${x:pid}&fileName=${x:fileName}&fsize=${size}&bucket=${bucket}&object=${object}&etag=${etag}&size=${size}&commitId=${x:commitId}&handle=${x:handle}&projectName=${x:projectName}&projectId=${x:projectId}&createdAt=${x:createdAt}';
        console.log('callback', {
            url: callbackUrl,
            body: callbackBody,
            customValue: {
                utoken: StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
                pid: '1',
                commitId: commitId,
                fileName: localName,
                handle: !isSelfProject ? 'adapt' : Number(projectId) > 0 ? 'edit' : 'create',
                projectName: projectName,
                projectId: String(projectId),
                coverImage: coverImage || 'null',
                createdAt: String(createdAt)
            }
        });
        this.client = client;
        return client.multipartUpload(commitId, file, {
            ...option,
            callback: {
                url: callbackUrl,
                body: callbackBody,
                customValue: {
                    utoken: StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
                    pid: '1',
                    commitId: commitId,
                    fileName: localName,
                    handle: !isSelfProject ? 'adapt' : Number(projectId) > 0 ? 'edit' : 'create',
                    projectName: projectName,
                    projectId: String(projectId),
                    coverImage: coverImage || 'null',
                    createdAt: String(createdAt)
                }
            }
        });
    }

    /**
     * 上传项目封面
     *
     * @param {any} config
     * @param {any} cb
     * @returns
     */
    uploadCoverImg(config, file, option) {
        const { region, accessKeyId, accessKeySecret, stsToken, bucket, commitId } = config;
        const client = new OSS({ region, accessKeyId, accessKeySecret, stsToken, bucket });
        this.client = client;
        return client.multipartUpload(commitId, file, option);
    }

    /**
     * 上传附件
     *
     * @param {any} config
     * @param {any} file
     * @returns
     */
    uploadAttachment(config, file, option) {
        const { region, accessKeyId, accessKeySecret, stsToken, bucket, commitId } = config;
        const client = new OSS({ region, accessKeyId, accessKeySecret, stsToken, bucket });
        this.client = client;
        return client.multipartUpload(commitId, file, option);
    }

    /**
     * 中断上传
     */
    abortUpload(name, uploadId) {
        if (this.client) {
            return this.client.abortMultipartUpload(name, uploadId);
        }
    }
}

export default new OssService();